var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnLinkEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3119 6.89453V0.644531H8.9786H0.645264V6.89453V13.1445H8.9786",
    stroke: "#CD2A3F",
    strokeWidth: 1.29032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3121 11.0625H11.4788",
    stroke: "#CD2A3F",
    strokeWidth: 1.29032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5621 8.97656L11.4788 11.0599L13.5621 13.1432",
    stroke: "#CD2A3F",
    strokeWidth: 1.29032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.645264 0.644531L8.9786 6.89453L17.3119 0.644531",
    stroke: "#CD2A3F",
    strokeWidth: 1.29032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLinkEmailIcon);
export default __webpack_public_path__ + "static/media/unLinkEmailIcon.6a9aaafc5bae362bfe9a27b57ccd7f85.svg";
export { ForwardRef as ReactComponent };